export function getPhoneNumberWithoutCountryPrefix(phone: string | null): string {
  if (!phone) return '';
  if (phone.startsWith('+')) return phone.substring(3);
  else return phone;
}
